import { apiClient } from 'axios-client';
import { SolicitationsTableQuery } from 'generated/graphql';
import React, { FunctionComponent, useCallback } from 'react';
import { ToastError, ToastSuccess } from 'utils';
import { Unpacked } from 'utils/unpacked';
import { ProBouncedSolicitationContainer } from './pro-bounced-solicitation-container';

type ProBouncedSolicitationRepositoryProps = {
  solicitation: Unpacked<SolicitationsTableQuery['solicitation']>;
  refetchSolicitations: () => void;
  resendMailToPro: (uuid: string, isEmailEdited?: boolean) => Promise<void>;
};

export const ProBouncedSolicitationRepository: FunctionComponent<
  ProBouncedSolicitationRepositoryProps
> = ({ solicitation, refetchSolicitations, resendMailToPro }) => {
  const reactivateEmailInPostmarkRequest = useCallback(async () => {
    await apiClient
      .post(`/form/contact-pro/reactivate-postmark-email`, {
        accountEmail: solicitation.proView.emailTarget,
      })
      .then(() => {
        ToastSuccess('Succès', "L'email du pro est réactivé");
      })
      .catch((error) => {
        ToastError(
          'Erreur',
          `Impossible de réactiver le mail du professionnel : ${error}`,
        );
      });
  }, [solicitation]);

  if (!solicitation.proView.emailTarget) {
    return <>error</>;
  }

  return (
    <ProBouncedSolicitationContainer
      refetchSolicitations={refetchSolicitations}
      reactivateEmailInPostmarkRequest={reactivateEmailInPostmarkRequest}
      emailTarget={solicitation.proView.emailTarget}
      resendMailToPro={resendMailToPro}
      solicitation={solicitation}
    />
  );
};
